const component = "planning-date-range-navigator";

export const planningDateRangeNavigator = {
  component,
  seePreviousRangeButton: `${component}/navigation/see-previous-range-button`,
  seeNextRangeButton: `${component}/navigation/see-next-range-button`,
  displayedTimeframe: `${component}/timeframe`,
};
